import { usePunditUserContext } from "@circle-react/contexts";

export const useIsVisualEmailBuilderEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(currentCommunitySettings?.visual_email_builder_enabled);
};
